export var WorkatoConnectionProvider;
(function (WorkatoConnectionProvider) {
    WorkatoConnectionProvider["HUBSPOT"] = "HUBSPOT";
    WorkatoConnectionProvider["MARKETO"] = "MARKETO";
    WorkatoConnectionProvider["SALESFORCE"] = "SALESFORCE";
    WorkatoConnectionProvider["PROVIDER_UNSPECIFIED"] = "PROVIDER_UNSPECIFIED";
})(WorkatoConnectionProvider || (WorkatoConnectionProvider = {}));
export var CompanyType;
(function (CompanyType) {
    CompanyType["Unspecified"] = "unspecified";
    CompanyType["Media"] = "media";
    CompanyType["Subscription"] = "subscription";
})(CompanyType || (CompanyType = {}));
//# sourceMappingURL=Company.js.map